import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { JsonLd } from 'react-schemaorg';

import { Breadcrumbs } from '@codex/basics';

import { getActiveListingPage } from '../../reduck/selectors';

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: ${({ useWiderBottomMargin }) => (useWiderBottomMargin ? '20px' : '10px')};
`;

const Breadcrumb = ({ breadcrumbData, useWiderBottomMargin }) => (
  breadcrumbData
    ? (
      <>
        <StyledBreadcrumbs useWiderBottomMargin={useWiderBottomMargin}>
          {breadcrumbData.map((currentBreadcrumbData, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <a key={i} href={currentBreadcrumbData.url || '#'}>
              {currentBreadcrumbData.label}
            </a>
          ))}
        </StyledBreadcrumbs>
        <JsonLd
          item={breadcrumbData.reduce((json, currentBreadcrumbData, i) => ({
            ...json,
            itemListElement: [
              ...json.itemListElement,
              {
                '@type': 'ListItem',
                'position': 1,
                'item': {
                  '@id': currentBreadcrumbData.url,
                  'name': currentBreadcrumbData.label
                }
              }
            ]
          }),
          {
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': []
          }
          )}
        />
      </>
    ) : null
);

Breadcrumb.propTypes = {
  breadcrumbData: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string
    }).isRequired
  ),
  useWiderBottomMargin: PropTypes.bool
};

Breadcrumb.defaultProps = {
  breadcrumbData: undefined,
  useWiderBottomMargin: false
};

const mapStateToProps = (state) => ({
  breadcrumbData: getActiveListingPage(state)?.breadcrumbData
});

export default connect(mapStateToProps)(Breadcrumb);
